/**
 * Custom-column cell for `project` columns (briefs trackers only). Read-only:
 * it surfaces the brief's own project — there is no per-cell value to edit.
 * Grouping a board by this column buckets its briefs by project.
 *
 * The title arrives with the row, so the cell makes no request.
 */
import { FolderOpen } from 'lucide-react';

import { EM_DASH } from './constants';

interface ProjectCustomCellProps {
  /** The brief's project id; absent on free-form items (renders a dash). */
  projectId?: string;
  /** The project's title, when its row carries one. */
  title?: string | null;
}

export function ProjectCustomCell({ projectId, title }: ProjectCustomCellProps) {
  if (!projectId) return <span className="text-muted-foreground">{EM_DASH}</span>;

  return (
    <span className="flex items-center gap-1.5 text-sm">
      <FolderOpen className="size-3.5 shrink-0 text-muted-foreground" aria-hidden />
      <span className="truncate">{title ?? '…'}</span>
    </span>
  );
}
